import { createFileRoute } from "@tanstack/react-router";

import { ClientAgreement } from "~/components/engagement/admin/client-agreement";
import { PaymentHistory } from "~/components/engagement/admin/payment-history";
import { PaymentInfo } from "~/components/engagement/admin/payment-info";
import { SessionProgress } from "~/components/engagement/admin/session-progress";
import { PageSection } from "~/components/ui/page-section";

export const Route = createFileRoute(
  "/_user/my-coaching/clients/programs/$engagementId/admin",
)({
  staticData: { title: "Billing & documents" },
  component: AdminPage,
});

function AdminPage() {
  const { engagementId } = Route.useParams();

  return (
    <div className="space-y-8">
      <PageSection title="Progress">
        <SessionProgress engagementId={engagementId} />
      </PageSection>

      <ClientAgreement engagementId={engagementId} />

      <PaymentInfo engagementId={engagementId} />

      <PaymentHistory engagementId={engagementId} />
    </div>
  );
}
